import { render, staticRenderFns } from "./eliminacion-residuos-ver.vue?vue&type=template&id=70bfe80c&scoped=true&"
import script from "./eliminacion-residuos-ver.vue?vue&type=script&lang=js&"
export * from "./eliminacion-residuos-ver.vue?vue&type=script&lang=js&"
import style0 from "./eliminacion-residuos-ver.vue?vue&type=style&index=0&id=70bfe80c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bfe80c",
  null
  
)

export default component.exports